
if (!customElements.get('avis-countdown')) {
    
    class AvisCountdown extends HTMLElement {
    constructor() {
        super();
        // 
        this.selectedElementData = null;

        this.isBuyingValid = false;
        this.avisPrivateRestriction = window.themeVariables.avisRestrictions.private_restriction || false;

        this.avisCountdown = this.querySelector('[data-avis-countdown]');

        this.countDownWrapper = document.createElement('span');
        this.countDownWrapper.classList.add('tw-font-bold');
        this.countDownWrapper.textContent = 'countdown';

        // Language-based day label ('d' for English URLs containing '/en/', else 'j')
        try {
            const path = window.location?.pathname || '';
            this.dayLabel = path.includes('/en/') ? 'd' : 'j';
        } catch (e) {
            this.dayLabel = 'j';
        }

        this.init();
    }

    connectedCallback() {
        // add event listener to the trigger submit button
        document.addEventListener('avis:reload', this.init.bind(this));
        document.addEventListener('avis:selected', this.init.bind(this));
    }

    disconnectedCallback() {
        // remove event listener to the trigger submit button
        document.removeEventListener('avis:reload', this.init.bind(this));
        document.removeEventListener('avis:selected', this.init.bind(this));
    }

    init() {
        console.log('init avis countdown');
        // get selected element data from session storage
        this.selectedElementData = this.getSelectedElementData();

        if( this.avisCountdown 
            && this.selectedElementData !== null 
            && this.selectedElementData.expoDay != null 
            && this.selectedElementData.expoHour != null) {

            if( this.avisPrivateRestriction && this.selectedElementData?.private == 'true' )
                this.isBuyingValid = false;
            else
                this.isBuyingValid = window.isAvisHasValidDate(this.selectedElementData.expoDay, this.selectedElementData.expoHour)
                                    && window.isAvisHasValidComplexe(this.selectedElementData.complexe);
            
            // Only proceed if the countdown element exists
            if ( this.avisCountdown ) {
                // Get the content and split by the placeholder
                let countDownContent = this.avisCountdown.textContent.split('#countdown#');
                
                if (countDownContent?.length > 1) {
                    // Clear the existing content
                    this.avisCountdown.innerHTML = '';
                    
                    // Create and append the first part as a text node
                    const firstPart = document.createTextNode(countDownContent[0]);
                    this.avisCountdown.appendChild(firstPart);
                    
                    // Append the countdown wrapper element
                    this.avisCountdown.appendChild(this.countDownWrapper);
                    
                    // Create and append the second part as a text node
                    const secondPart = document.createTextNode(countDownContent[1]);
                    this.avisCountdown.appendChild(secondPart);
                }
                else {
                    console.log('Countdown content not found');
                }
            }
            else {
                console.log('Buying is restricted');
            }

            this.setCountdownTimer(this.isBuyingValid);
        }
        else {
            console.log('No countdown to show');
            this.avisCountdown?.classList?.add('hidden');
        }
    }

    getSelectedElementData() {
        if (this.hasAttribute('data-single-avis')) {
            return {
                expoDay: this.getAttribute('data-expoday'),
                expoHour: this.getAttribute('data-expohour'),
                complexe: this.getAttribute('data-complexe')
            };
        }
        return JSON.parse(sessionStorage.getItem('avisDataProduct'));
    }
    
    setCountdownTimer(show) {
        if (show && this.avisCountdown && this.selectedElementData?.expoDay && this.selectedElementData?.expoHour) {
            // Parse the date and time from French format
            const dateString = this.selectedElementData.expoDay;
            const hourString = this.selectedElementData.expoHour;
            
            // Month mappings (French → English)
            const monthsFrToEn = {
                "janvier": "January", "février": "February", "mars": "March",
                "avril": "April", "mai": "May", "juin": "June",
                "juillet": "July", "août": "August", "septembre": "September",
                "octobre": "October", "novembre": "November", "décembre": "December"
            };

            // Day mappings (French → English)
            const daysFrToEn = {
                "lundi": "Monday", "mardi": "Tuesday", "mercredi": "Wednesday",
                "jeudi": "Thursday", "vendredi": "Friday", "samedi": "Saturday", "dimanche": "Sunday"
            };

            // Convert French date to English for parsing
            let parts = dateString.trimStart().toLowerCase().replace(" le ", " ").split(" ");
            let dayName = daysFrToEn[parts[0]] || parts[0];
            let day = parts[1];
            let month = monthsFrToEn[parts[2]] || parts[2];
            let year = parts[3];
            
            let dateFormatted = `${dayName}, ${day} ${month} ${year}`;
            
            // Parse time (take the first time in the range)
            let timeParts = hourString.match(/(\d{1,2}):(\d{2})/);
            let hour = parseInt(timeParts[1], 10);
            let minute = parseInt(timeParts[2], 10);
            
            // Create the target date
            let targetDate = new Date(dateFormatted);
            targetDate.setHours(hour, minute, 0, 0);

            // Create and start the countdown
            this.startCountdown(targetDate);
            
            this.avisCountdown.classList.remove('hidden');
        } else {
            this.avisCountdown?.classList?.add('hidden');
        }
    }
    
    startCountdown(targetDate) {
        // Clear any existing interval
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
        }

        const computeRemaining = () => {
            const now = new Date();
            let diff = targetDate - now;
            if (diff <= 0) diff = 0;

            // Apply restriction threshold (in hours) if configured (>0)
            const restrictionThreshold = window.themeVariables?.avisRestrictions?.restriction_threshold || 48;
            if (restrictionThreshold > 0) {
                diff -= restrictionThreshold * 60 * 60 * 1000;
                if (diff < 0) diff = 0;
            }

            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((diff % (1000 * 60)) / 1000);
            return { days, hours, minutes, seconds, diff };
        };

        const render = () => {
            const { days, hours, minutes, seconds, diff } = computeRemaining();

            if (diff <= 0) {
                // Time is up
                clearInterval(this.countdownInterval);
                this.avisCountdown?.classList?.add('tw-hidden');
                this.avisCountdown?.classList?.add('hidden');
                return { live: false };
            }

            let text = '';
            let live = false;

            // Display/refresh rules
            if (days > 1) {
                text = `${days}${this.dayLabel}`;
                live = false; // no live refresh
            } else if (days === 1) {
                text = `${days}${this.dayLabel} ${hours}h`;
                live = false; // no live refresh
            } else { // days === 0
                if (hours >= 12) {
                    text = `${hours}h ${minutes}m`;
                    live = false; // no live refresh
                } else {
                    text = `${hours}h ${minutes}m ${seconds}s`;
                    live = true; // live refresh
                }
            }

            this.countDownWrapper.innerHTML = text;
            return { live };
        };

        // Initial render
        const state = render();

        // Start/skip interval based on rule
        if (state.live) {
            this.countdownInterval = setInterval(render, 1000);
        } else {
            if (this.countdownInterval) clearInterval(this.countdownInterval);
        }
    }
    }

    customElements.define('avis-countdown', AvisCountdown);
}